import React from 'react';
import { useTranslation } from 'react-i18next';
import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';
import PayloadCarrierCountSimpleTextSchema from './PayloadCarrierCountSimpleTextSchema';
import { Popover } from 'devextreme-react';
import { useId } from 'react-id-generator';
import { IdType } from 'fulogics-ui-core';
import {
    StyledContainer,
    StyledInfoWrapper,
    StyledLabel,
    StyledValue,
    StyledTypeDetails,
} from './styled';

const PayloadCarrierCountSimpleText = ({
    data,
    className,
    hideStackInfo,
}: PayloadCarrierCountSimpleTextProps) => {
    const { t } = useTranslation('PayloadCarrierCountSimpleText');
    const carrierTypesByCount = data?.carrierTypesByCount || [];
    const haveOneType = carrierTypesByCount.length === 1;
    const [targetId] = useId();

    return (
        <>
            <label className={className}>
                {data?.carriersQuantity || 0}{' '}
                {haveOneType ? (
                    <StyledLabel>
                        ({carrierTypesByCount[0]?.carrierType?.measurements?.length}x
                        {carrierTypesByCount[0]?.carrierType?.measurements?.width})
                        {hideStackInfo
                            ? ''
                            : ` ${carrierTypesByCount[0]?.maximumStackLayers || 1}p`}
                    </StyledLabel>
                ) : (
                    <StyledLabel>
                        (<StyledTypeDetails id={targetId}>{t('variousTypes')}</StyledTypeDetails>)
                    </StyledLabel>
                )}
            </label>
            <Popover
                target={`#${targetId}`}
                showEvent="dxhoverstart"
                hideEvent="dxhoverend"
                width="315px"
                height="auto"
                position="top"
                showTitle={false}
            >
                <StyledContainer>
                    <h5>{t('title')}</h5>
                    <div>
                        <StyledInfoWrapper>
                            <StyledLabel>{t('grid.type')}</StyledLabel>
                            {!hideStackInfo && <StyledLabel>{t('grid.stack')}</StyledLabel>}
                            <StyledLabel>{t('grid.amount')}</StyledLabel>
                        </StyledInfoWrapper>
                        {carrierTypesByCount?.map((type, index) => (
                            <StyledInfoWrapper key={`${type.carrierType?.id}-${index}-${targetId}`}>
                                <StyledValue>
                                    {type?.carrierType?.measurements?.length} x
                                    {type?.carrierType?.measurements?.width}
                                </StyledValue>
                                {!hideStackInfo && (
                                    <StyledValue>{type?.maximumStackLayers || 1}</StyledValue>
                                )}
                                <StyledValue>{type?.count || 0}</StyledValue>
                            </StyledInfoWrapper>
                        ))}
                    </div>
                </StyledContainer>
            </Popover>
        </>
    );
};

export type PayloadCarrierCountSimpleTextProps = {
    data?: PayloadCarrierCountSimpleTextData;
} & PayloadCarrierCountSimpleTextDisplayOptions;

export default withInspector<PayloadCarrierCountSimpleTextProps>(
    PayloadCarrierCountSimpleText,
    PayloadCarrierCountSimpleTextSchema
);

export class PayloadCarrierCountSimpleTextDisplayOptions {
    id?: string;
    className?: string;
    //
    hideStackInfo?: boolean;
}

export type PayloadCarrierCountSimpleTextData = {
    carriersQuantity?: number;
    carrierTypesByCount?: {
        count?: number;
        carrierType?: {
            id?: IdType;
            measurements?: {
                length?: number;
                width?: number;
            };
        };
        maximumStackLayers?: number;
    }[];
};

export const PayloadCarrierCountSimpleTextDataKeys = [
    'carriersQuantity',
    'carrierTypesByCount.count',
    'carrierTypesByCount.carrierType.measurements.length',
    'carrierTypesByCount.carrierType.measurements.width',
    'carrierTypesByCount.maximumStackLayers',
];
